export default [
  {
    description: 'Default',
  },
  {
    description: 'OverrideTexts + HTML',
    texts: {
      productName: 'Product Name <b>Test HTML Tag</b>',
      regularPriceOverrideText: 'regularPriceOverrideText <strong>xyz</strong>',
      catalogueDetailsButtonLabel: 'catalogueDetailsButtonLabel xyz',
      providerName: 'Provider <b>Name HTML</b>',
    },
  },
  {
    description: 'catalogueRegularDisruptorText',
    texts: {
      catalogueRegularDisruptorText: 'Regular Disruptor',
    },
  },
  {
    description: 'cataloguePromotionDisruptorText',
    texts: {
      catalogueRegularDisruptorText: 'WRONG!',
      cataloguePromotionDisruptorText: 'cataloguePromotion<br>DisruptorText <i>xyz</i>',
    },
  },
  {
    description: 'cataloguePromotionDisruptorText W/O Promotion Price',
    texts: {
      catalogueRegularDisruptorText: 'Correct',
      cataloguePromotionDisruptorText: 'WRONG!',
    },
    price: {
      promotion: null,
    },
  },
  {
    description: 'Long description text',
    texts: {
      productDescriptionCatalogue:
        'This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. <b>This is a very long text.</b> This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text. This is a very long text.',
    },
  },
  {
    description: 'Promotion Price Override Text NOT VISIBLE',
    texts: {
      promotionPriceOverrideText: 'promotionPriceOverrideText xyz',
    },
  },
  {
    description: 'No Image',
    images: {
      productLogoCatalogueResourcePath: null,
    },
  },
  /** disabled, because there will be a server request in create hook.
  {
    description: 'hasUndefinedAvailability',
    productAvailability: 'undefinedAvailability',
  },
  */
  {
    description: 'hasNoneAvailability',
    productAvailability: 'noneAvailability',
  },
  {
    description: 'BADGE: In Progress',
    orderedInstances: 1,
  },
  {
    description: 'BADGE: Reserved',
    reservedInstances: 1,
    currentInstances: 1,
  },
  {
    description: 'BADGE: Already purchased',
    currentInstances: 1,
    maxInstances: 1,
  },
  {
    description: 'BADGE: Already purchased several times',
    currentInstances: 5,
    maxInstances: 5,
  },
  {
    description: 'BADGE: Already purchased 5 times',
    currentInstances: 5,
    maxInstances: 10,
  },
];
